import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { STATE__workspace } from '../STATE__workspace';

export const local_workspace_user_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.WORKSPACE_USER_DELETE,
  payload,
});

export const init_local_workspace_user_delete = (state: STATE__workspace, action: PayloadAction<string[]>) => {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    if (state.current_workspace_user._id == id) {
      state.current_workspace_user = DTO__workspace_user.CREATE_STUB();
    }

    let users_in_workspace_dto = Array.from(state.all_workspaces_users_map.values()).flatMap(innerMap => Array.from(innerMap.values()));

    let user_in_workspace = users_in_workspace_dto.find(item => item._id == id);

    //could be null if user is still not received user tasks during auth
    if (!user_in_workspace) continue;

    let users_map = state.all_workspaces_users_map.get(user_in_workspace.workspace_id);

    if (!users_map) continue;

    users_map.delete(user_in_workspace.user_id);
  }

  //refresh map to trigger re-render
  state.all_workspaces_users_map = new Map(state.all_workspaces_users_map);
};
